import type { FC } from 'react';

import VolatilityRangeWidget from './volatility-range-widget';
import { VolatilityRangeProvider } from '../../../../providers/widgets/volatility-range-provider/volatility-range-provider';
import { VolatilityRangeProps } from './types';

const VolatilityRangeWrapperProvider: FC<VolatilityRangeProps> = (props) => (
  <VolatilityRangeProvider providerKey={props.providerKey}>
    <VolatilityRangeWidget {...props} />
  </VolatilityRangeProvider>
);

export default VolatilityRangeWrapperProvider;
